import { render, staticRenderFns } from "./view_list.vue?vue&type=template&id=6beb528f"
import script from "./view_list.vue?vue&type=script&lang=js"
export * from "./view_list.vue?vue&type=script&lang=js"
import style0 from "./view_list.vue?vue&type=style&index=0&id=6beb528f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports